import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { useMsal } from "@azure/msal-react";


export const datosCaeSlice = createSlice({
    name: 'datosCae', //importante, ya que se realizara llamdo mas tarde por nombre
    initialState: {
        datosCae: { data: [] }
    },
    reducers: {
        setDatosCae: (state, action) => {  //crear set
            state.datosCae = action.payload
        }
    }
})


export const { setDatosCae } = datosCaeSlice.actions

export default datosCaeSlice.reducer


export const getDatosCae = (accounts) => async (dispatch) => {



    //dispatch(setSesion(accounts))
    const mail_estudiante = accounts[0].username
    //console.log("mail_estudiante",mail_estudiante)


    try {

        return await axios
            .post(
                'https://ws.ugm.cl/api/v1_ufe/ufe_getDatosCae', { mail_estudiante: mail_estudiante },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_TOKEN
                    }
                }
            )
            .then(response => {
                console.log('dispatch datosCae', response.data)
                

                
                dispatch(setDatosCae(response.data))
                return response.data
            })

    } catch (error) {

        //console.log('dispatch error', error)

    }
 

}